import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { Phone, Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  const phone = "+91 9900186556";
  const email = "Buildbrigadeenterprises@gmail.com";
  return (
    <footer className="bg-[#EDE6D3] text-[#0A2342] mt-32" data-testid="site-footer">
      <div className="border-b border-[#0A2342]/10 py-8 overflow-hidden">
        <Marquee gradient={false} speed={40} pauseOnHover>
          {["Hoskote", "Whitefield", "Devanahalli", "Yelahanka", "Peenya", "ORR Bengaluru", "Jubilee Hills Extn.", "Sarjapur", "Hebbal", "Electronic City"].map((c, i) => (
            <span key={i} className="marquee-outline-cream font-serif text-[64px] md:text-[92px] leading-none px-10 tracking-tight">{c} —</span>
          ))}
        </Marquee>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <img src="/bbe-logo.png" alt="BBE" className="h-14 w-auto object-contain" />
            <div className="leading-none">
              <div className="font-display text-[17px] tracking-[1px]">Build Brigade</div>
              <div className="text-[9px] tracking-[3px] uppercase text-[#D4AF37] mt-[2px]">Enterprises</div>
            </div>
          </div>
          <p className="font-serif text-[22px] md:text-[26px] leading-[1.25] max-w-md">
            Engineering value across the entire real estate lifecycle — from raw land to institutional exit.
          </p>
          <div className="mt-8 space-y-3 text-[13px] text-[#0A2342]/80">
            <a href={`tel:${phone.replace(/\s+/g, "")}`} className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors" data-testid="footer-phone">
              <Phone size={14} color="#D4AF37" /> {phone}
            </a>
            <a href={`mailto:${email}`} className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors break-all" data-testid="footer-email">
              <Mail size={14} color="#D4AF37" /> {email}
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow text-[#D4AF37] mb-5">Verticals</div>
          <ul className="space-y-3 text-[13px]">
            <li><Link to="/properties" className="link-underline">Properties & Land</Link></li>
            <li><Link to="/services" className="link-underline">Turnkey Construction</Link></li>
            <li><Link to="/nri" className="link-underline">NRI Management</Link></li>
            <li><Link to="/services" className="link-underline">Commercial Leasing</Link></li>
            <li><Link to="/portal" className="link-underline">Distressed & JV</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow text-[#D4AF37] mb-5">Company</div>
          <ul className="space-y-3 text-[13px]">
            <li><Link to="/" className="link-underline">Home</Link></li>
            <li><Link to="/services" className="link-underline">Services</Link></li>
            <li><Link to="/portal" className="link-underline">Portals</Link></li>
            <li><Link to="/contact" className="link-underline">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow text-[#D4AF37] mb-5">Presence</div>
          <ul className="space-y-3 text-[13px]">
            <li>Bengaluru</li>
            <li className="text-[#0A2342]/40 text-[11px]">Est. 2026</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#0A2342]/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between text-[11px] tracking-[2px] uppercase text-[#0A2342]/60 gap-3">
          <div>© {year} Build Brigade Enterprises · Bengaluru · All Rights Reserved.</div>
          <div>RERA · SEBI-registered advisor · Institutional-grade underwriting</div>
        </div>
      </div>
    </footer>
  );
}
